/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [{ packageDetails: vp.PackageDetails }, (packageId: string) => void];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchBillingPackagesDetails: ApiHook = ({ api }) => {
  const source = axios.CancelToken.source();

  const [packageId, setPackageId] = useState('');
  const [packageDetails, setPackageDetails] = useState({});

  useEffect(() => {
    const loadData = async () => {
      const { PackageDetails } = await api.fetchBillingPackageDetails({ PackageID: packageId }, source);

      if (PackageDetails) setPackageDetails(PackageDetails);
    };

    if (packageId) void loadData();

    return () => {
      source.cancel();
    };
  }, [packageId]);

  return [{ packageDetails }, (_packageId: string) => setPackageId(_packageId)];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchBillingPackagesDetails);
